import React from "react";

const Contact = () => {
  return <div>
  {/* Contact Information */}
  
  </div>;
};

export default Contact;
